module.exports = __webpack_public_path__ + "img/minus-line-svgrepo-com (1).8cd23525.svg";